<template>
  <div class="app-compliance">
    <div class="app-compliance-filter">
      <div class="app-compliance-filter-tabs">
        <a-radio-group v-model:value="deviceType" @change="handleDeviceType">
          <a-radio-button value="android">
            <android-outlined />
            Android
          </a-radio-button>
          <a-radio-button value="ios">
            <apple-outlined />
            iOS
          </a-radio-button>
        </a-radio-group>
      </div>
      <div class="app-compliance-filter-datepicker">
        <RangePicker
          @dataPickerTime="selectTime"
          :defaultDate="defaultDate"
          :timeFrame="90"
        />
      </div>
      <span class="search-btn search-btn-primary" @click="handleDownLoad">
        下载统计数据
      </span>
      <div class="downLoad-info">
        <a-tooltip>
          <template #title> 将统计当前筛选条件下的风险数据 </template>
          <InfoCircleOutlined />
        </a-tooltip>
      </div>
    </div>
    <div class="complianceBox">
      <div class="complianceTop">
        <div class="risk">
          <div class="complianceHeader">风险应用占比</div>
          <div class="complianceBody">
            <Container>
              <template #default>
                <riskApp :data="riskAppData" />
              </template>
            </Container>
          </div>
        </div>
        <div class="stage">
          <div class="complianceHeader">风险阶段分布</div>
          <div class="complianceBody">
            <Container>
              <template #default>
                <StageLine :data="riskAppData.activity" />
              </template>
            </Container>
          </div>
        </div>
        <div class="applicationBox">
          <div class="application">
            <div class="complianceHeader">风险应用 TOP 10</div>
            <div class="complianceBody">
              <Container>
                <template #default>
                  <RiskPic
                    :barData="modelData"
                    :chartIndex="0"
                    tooltipAlert="风险数"
                    :colorPic="[
                      'rgba(187, 239, 255,0)',
                      'rgba(69, 188, 255,1)'
                    ]"
                  />
                </template>
              </Container>
            </div>
          </div>
          <div class="applicationSDK">
            <div class="complianceHeader">风险 SDK TOP 10</div>
            <div class="complianceBody">
              <Container>
                <template #default>
                  <RiskPic
                    :barData="modelDataSdk"
                    :chartIndex="1"
                    :colorPic="[
                      'rgba(255, 153, 102,0)',
                      'rgba(255, 153, 102,1)'
                    ]"
                  />
                </template>
              </Container>
            </div>
          </div>
        </div>
      </div>
      <div class="complianceBotton">
        <div class="type">
          <div class="complianceHeader">风险类型分布</div>
          <div class="complianceBody">
            <Container>
              <template #default>
                <Pie :data="modelDataVul" />
              </template>
            </Container>
          </div>
        </div>
        <div class="behavior">
          <div class="complianceHeader">敏感行为统计</div>
          <div class="complianceBody">
            <Container pd="0">
              <template #default>
                <BisePie :data="activitySummary" />
              </template>
            </Container>
          </div>
        </div>
        <div class="riskNum">
          <div class="complianceHeader">检出风险数量变化</div>
          <div class="complianceBody">
            <Container>
              <template #default>
                <Lines :data="thend" :deviceType="deviceType" />
              </template>
            </Container>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';
import dayjs from 'dayjs';
import RangePicker from '@/components/common/range-picker.vue';
import Container from './common/container.vue';
import RiskPic from './common/riskPic.vue';
import BisePie from './common/bisePie';
import Lines from './common/lines.vue';
import riskApp from './common/riskApp.vue';
import Pie from './common/pie.vue';
import StageLine from './common/stageLine.vue';
import { AppleOutlined, AndroidOutlined, InfoCircleOutlined } from '@ant-design/icons-vue';
import { getcomplianceData, getDownLoad } from '@/api/appCompliance.js';
export default {
  name: 'HomePage',
  components: {
    Container,
    RiskPic,
    BisePie,
    Lines,
    riskApp,
    Pie,
    StageLine,
    RangePicker,
    AppleOutlined,
    AndroidOutlined,
    InfoCircleOutlined
  },
  setup() {
    //演示数据用
    const defaultDate = localStorage.rangeDate?.split(',') || [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")];
    let starttime = dayjs(defaultDate[0]).format("YYYY-MM-DD");
    let endtime = dayjs(defaultDate[1]).format("YYYY-MM-DD");
    const appData = reactive({
      starttime,
      endtime
    });
    const modelData = ref([]);
    const modelDataSdk = ref([]);
    const modelDataVul = ref([]);
    const activitySummary = ref({});
    const riskAppData = ref({});
    const thend = ref([]);
    const deviceType = ref('android');
    const getData = async () => {
      let { data } = await getcomplianceData({
        ...appData,
      });
      if (data) {
        let newData = data[deviceType.value];
        riskAppData.value = newData;
        modelData.value = newData.app.map(item => ({ name: item.name, value: item.total }));
        modelDataSdk.value = newData.sdk.map(item => ({ name: item.name, value: item.total }));
        modelDataVul.value = newData.vul.map((item, index) => {
          if (index == 0) {
            return { name: item.name, value: item.total, label: { show: index == 0 } };
          }
          return { name: item.name, value: item.total };
        });
        activitySummary.value = newData.activitySummary;
        thend.value = newData.trend.map(item => ({ name: item.time.replace(/-/g, '/'), value: item.total }));
      }
    };
    const handleDeviceType = (e) => {
      const val = e.target.value;
      deviceType.value = val;
      getData();
    };
    // 下载数据
    const handleDownLoad = () => {
      let params = {
        type: deviceType.value === 'android' ? 1 : 2,
        starttime: appData.starttime,
        endtime: appData.endtime
      };
      getDownLoad(params);
    };
    getData();
    const selectTime = (val) => {
      if (val) {
        appData.starttime = dayjs(val[0]).format("YYYY-MM-DD");
        appData.endtime = dayjs(val[1]).format("YYYY-MM-DD");
        getData();
      }
    };
    return {
      modelData,
      modelDataSdk,
      modelDataVul,
      activitySummary,
      thend,
      riskAppData,
      appData,
      selectTime,
      defaultDate,
      deviceType,
      handleDeviceType,
      handleDownLoad
    };
  },
}
</script>
<style scoped lang="less">
@import url('./index.less');
</style>